import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/estimateTemplateActions'
import * as api from '../../api/job/jobs'

function* getEstimateTemplates(action) {
  try {
    const payload = yield call(api.getEstimateTemplates, action.jobId)
    yield put({ type: constants.GET_ESTIMATE_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ESTIMATE_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetEstimateTemplates() {
  yield takeLatest(constants.GET_ESTIMATE_TEMPLATES.ACTION, getEstimateTemplates)
}

function* getTemplateSections(action) {
  try {
    const payload = yield call(api.getTemplateSecions, action.templateId)
    yield put({ type: constants.GET_TEMPLATE_SECTIONS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_TEMPLATE_SECTIONS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTemplateSections() {
  yield takeLatest(constants.GET_TEMPLATE_SECTIONS.ACTION, getTemplateSections)
}

function* getTemplateItems(action) {
  try {
    const payload = yield call(api.getTemplateItems, action.templateId)
    payload.data &&
      payload.data.forEach(d => {
        if (d.remove_default_tax === undefined) {
          d.remove_default_tax = true
        }
        if (d.remove_default_overhead === undefined) {
          d.remove_default_overhead = true
        }
        if (d.remove_default_markup === undefined) {
          d.remove_default_markup = true
        }
      })
    yield put({ type: constants.GET_TEMPLATE_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_TEMPLATE_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTemplateItems() {
  yield takeLatest(constants.GET_TEMPLATE_ITEMS.ACTION, getTemplateItems)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchGetEstimateTemplates),
    fork(watchGetTemplateSections),
    fork(watchGetTemplateItems)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/estimateTemplateSaga.js